export default {
  routes: [],

  dialogs: [
    {
      name: "user-paycheck-new",
      path: "/commission/paychecks/new",
      component: () => import("../../../dialogs/employee/PaycheckEdit"),
    },
    {
      name: "user-paycheck-edit",
      path: "/commission/paychecks/:paycheckID/edit",
      component: () => import("../../../dialogs/employee/PaycheckEdit"),
    },
    {
      name: "user-paycheck-view",
      path: "/commission/paychecks/:paycheckID/view",
      component: () => import("../../../dialogs/employee/PaycheckView"),
    },
  ],
};
